import React, { Component } from 'react'

import moment from 'moment'
import { Spinner, Row, Col } from 'reactstrap'

import { _global } from '../../utils/global'
import Badge from '../common/badge'
import Grid from '../grid/grid'

import './styles/style.scss'
import PracticeReportExpandedRow from './PracticeReportExpandedRow'

class PracticeReports extends Component {
  state = {
    expandedRowKeys: [],
  }

  actions = {
    collapseOpenRecords: () => {
      this.setState({
        expandedRowKeys: [],
      })
    },
    handleRowClick: (record, rowIndex, e) => {
      e.preventDefault()
      e.stopPropagation()

      this.setState(state => {
        const rowIndex = state.expandedRowKeys.indexOf(record.memberUuid)
        const expanded = rowIndex >= 0
        let data = []
        // Only display one detail view at one time
        if (expanded) {
          data = []
        } else {
          data = [record.memberUuid]
        }

        return {
          expandedRowKeys: data,
        }
      })
    },

    handleRowClassName: record => {
      const checked = this.state.expandedRowKeys.indexOf(record.memberUuid)
      const active = checked >= 0
      if (active) {
        return 'table-row-hover table-row tr-active'
      }
      return 'table-row-hover table-row'
    },

    handleRenderActionColumn: (text, record) => {
      const { expandedRowKeys } = this.state
      const expanded = expandedRowKeys.indexOf(record.memberUuid) >= 0
      let className = 'expandIcon'
      if (expanded) {
        className += ' rowExpanded'
      } else {
        className += ' rowCollapsed'
      }
      return <span className={className} />
    },

    activeRowClass: (record, key) => {
      const rowIndex = this.state.expandedRowKeys.indexOf(record.memberUuid)
      const expanded = rowIndex >= 0
      if (expanded) {
        return 'row-default'
      }
      return 'row-default row-active'
    },
  }

  columns = [
    {
      title: '',
      key: 'memberUuid',
      render: this.actions.handleRenderActionColumn,
      width: 20,
    },
    {
      title: 'STATUS',
      sortable: true,
      width: 80,
      key: 'status',
      render: (value, row, index) => {
        const getColor = status => {
          switch (status) {
            case 'active':
              return 'green'

            case 'cobra':
              return 'yellow'

            default:
              return 'red'
          }
        }

        return (
          <Badge color={getColor((row.status ?? '').toLowerCase())} capitalize solid>
            {row.displayStatus}
          </Badge>
        )
      },
    },
    {
      title: 'MEMBER ID',
      sortable: true,
      width: 130,
      key: 'memberId',
      render: (value, row, index) => {
        return (
          <div className={row.memberId && row.memberId.toLowerCase()}>
            {_global.properCase(row.memberId)}
          </div>
        )
      },
    },
    {
      title: 'TYPE',
      sortable: true,
      width: 110,
      key: 'memberType',
      render: (value, row, index) => {
        return _global.properCase(row.memberType)
      },
    },
    {
      title: 'FIRST NAME',
      sortable: true,
      width: 140,
      key: 'firstName',
      render: (value, row, index) => {
        return _global.properCase(row.firstName)
      },
    },
    {
      title: 'LAST NAME',
      sortable: true,
      key: 'lastName',
      width: 140,
      render: (value, row, index) => {
        return _global.properCase(row.lastName)
      },
    },
    {
      title: 'DOB',
      sortable: true,
      width: 105,
      key: 'dateOfBirth',
      render: (value, row, index) => {
        return row.dateOfBirth ? moment(row.dateOfBirth).format('L') : '-'
      },
    },
    {
      title: 'PCP NAME',
      sortable: true,
      width: 200,
      key: 'pcpName',
      render: (value, row, index) => {
        return _global.properCase(row.pcpName)
      },
    },
    {
      title: 'NPI',
      sortable: true,
      width: 95,
      key: 'NPI',
      render: (value, row, index) => {
        return row.NPI
      },
    },
    {
      title: 'ASSIGNMENT DATE',
      sortable: true,
      width: 140,
      key: 'assignmentDate',
      render: (value, row, index) => {
        return row.assignmentDate ? moment(row.assignmentDate).format('L') : '-'
      },
    },
  ]

  render() {
    const { memberSearchResults } = this.props
    const { loading } = this.props.practiceReports
    const { columns } = this

    return (
      <div className="management-list col-md-12">
        {loading && (
          <div className="text-center overlay">
            <Spinner color="dark" className="loader-centivo" />
          </div>
        )}
        {!this.props.practiceReports.reportSubmitted &&
          this.props.extendLoader && (
            <div className="text-center overlay">
              <Spinner color="dark" className="loader-centivo" />
            </div>
          )}

        {memberSearchResults && memberSearchResults.length > 0 ? (
          <Grid
            rowKey={record => record.memberUuid}
            columns={columns}
            hoverable={false}
            justified={false}
            sortable
            data={memberSearchResults}
            useFixedHeader
            onRowClick={this.actions.handleRowClick}
            rowClassName={this.actions.handleRowClassName}
            clientSidePagination={memberSearchResults.length > 10}
            defaultSortableKey="startDate"
            expandedRowRender={record => (
              <PracticeReportExpandedRow {...record} />
            )}
            expandedRowKeys={this.state.expandedRowKeys}
            collapseOpenRecords={this.actions.collapseOpenRecords}
          />
        ) : (
          memberSearchResults &&
          memberSearchResults.length === 0 && (
            <div className="no-data">
              There are no referrals to your practice
            </div>
          )
        )}
      </div>
    )
  }
}

export default PracticeReports
